module.exports = __webpack_public_path__ + "img/stratasys.ca6d42e4.png";